__turbopack_context__.v({
  "action": "Spotlight-module-scss-module__0SSBLW__action",
  "actionSection": "Spotlight-module-scss-module__0SSBLW__actionSection",
  "actionsGroup": "Spotlight-module-scss-module__0SSBLW__actionsGroup",
});
